export default "__VITE_ASSET__Ug_0$Acn__"